import React from 'react';
import { Filter } from 'lucide-react';

interface FiltersProps {
  titles: string[];
  genres: string[];
  artists: string[];
  languages: string[];
  selectedTitle: string;
  selectedGenre: string;
  selectedArtist: string;
  selectedLanguage: string;
  onTitleChange: (title: string) => void;
  onGenreChange: (genre: string) => void;
  onArtistChange: (artist: string) => void;
  onLanguageChange: (language: string) => void;
}

export function Filters({
  titles,
  genres,
  artists,
  languages,
  selectedTitle,
  selectedGenre,
  selectedArtist,
  selectedLanguage,
  onTitleChange,
  onGenreChange,
  onArtistChange,
  onLanguageChange,
}: FiltersProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:flex-wrap">
      <div className="flex items-center gap-2 w-full sm:w-auto">
        <Filter className="h-5 w-5 text-purple-600" />
        <span className="text-sm font-medium">Filtres:</span>
      </div>
      <select
        value={selectedTitle}
        onChange={(e) => onTitleChange(e.target.value)}
        className="rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="">Tous les titres</option>
        {titles.map((title) => (
          <option key={title} value={title}>
            {title}
          </option>
        ))}
      </select>
      <select
        value={selectedGenre}
        onChange={(e) => onGenreChange(e.target.value)}
        className="rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="">Tous les genres</option>
        {genres.map((genre) => (
          <option key={genre} value={genre}>
            {genre}
          </option>
        ))}
      </select>
      <select
        value={selectedArtist}
        onChange={(e) => onArtistChange(e.target.value)}
        className="rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="">Tous les interprètes</option>
        {artists.map((artist) => (
          <option key={artist} value={artist}>
            {artist}
          </option>
        ))}
      </select>
      <select
        value={selectedLanguage}
        onChange={(e) => onLanguageChange(e.target.value)}
        className="rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="">Toutes les langues</option>
        {languages.map((language) => (
          <option key={language} value={language}>
            {language}
          </option>
        ))}
      </select>
    </div>
  );
}